module.exports = __webpack_public_path__ + "img/167.feb3bad3.jpg";